__webpack_require__.p = "/demo/react/antdesign/tech/";